export default "__VITE_ASSET__9efa547e__"